// pricing-calculator/context/CalculatorProvider.tsx
// React context + provider for the calculator state and spec.

import React, { createContext, useContext, PropsWithChildren } from 'react';
import type {
  CalculatorActions,
  CalculatorContextValue,
  CalculatorSpec,
  ShareableCalculatorState,
} from '@dopomogai/types';
import { useCalculatorState } from './hooks/useCalculatorState';

const CalculatorContext = createContext<CalculatorContextValue | undefined>(undefined);

type ProviderProps = PropsWithChildren<{
  spec: CalculatorSpec;
  prefill?: ShareableCalculatorState;
}>;

export function CalculatorProvider({ spec, prefill, children }: ProviderProps) {
  const { state, actions } = useCalculatorState(spec, { prefill });

  const value: CalculatorContextValue = {
    spec,
    state,
    actions: actions as CalculatorActions,
  };

  return <CalculatorContext.Provider value={value}>{children}</CalculatorContext.Provider>;
}

export function useCalculator(): CalculatorContextValue {
  const ctx = useContext(CalculatorContext);
  if (!ctx) {
    throw new Error('useCalculator must be used within a CalculatorProvider');
  }
  return ctx;
}
